import { cloneElement, forwardRef, useRef } from 'react';

import PropTypes from 'prop-types';

import * as Styled from './MenuItem.style';

// eslint-disable-next-line no-unused-vars
const MenuItem = forwardRef(({ children, onClick = () => {}, variant }, ref) => {
  const linkRef = useRef(null);

  const items = cloneElement(children, {
    ref: linkRef
  });

  return (
    <Styled.Root
      onClick={onClick}
      onKeyDown={(e) => {
        // This is necessary to trigger link when keyboard navigation
        if (e.key === 'Enter') {
          linkRef.current.click();
        }
      }}
      role="presentation"
      tabIndex={-1}
      variant={variant}
    >
      {items}
    </Styled.Root>
  );
});

MenuItem.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  variant: PropTypes.string
};

export default MenuItem;
